export enum EntryType {
  epub = "epub",
  doc = "doc",
  pdf = "pdf",
  folder = "folder",
  txt = "txt",
  unknown = "unknown",
}

export interface Entry {
  id: string;
  name: string;
  type: EntryType;
  size?: number;
  createdTime?: string;
}

export enum ImportType {
  computerUpload = "computerUpload",
  dropbox = "dropbox",
  googleDrive = "googleDrive",
  writtenText = "writtenText",
}
